module.exports = __webpack_public_path__ + "static/media/basketball.ec10f891.svg";